import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
import DownloadAsync from '../download/async';

export default [
  <Route
    key="/business/color-trends/download"
    element={<DefaultBusinessLayout />}
  >
    <Route path="business/color-trends/download" element={<DownloadAsync />} />
  </Route>,
  <Route
    key="/business/color-trends/:id?"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Color Trends',
            item: '/business/color-trends',
          },
        ]}
      />
    }
  >
    <Route path="business/color-trends/:id?" element={<AsyncPage />} />
  </Route>,
];
